import React from 'react';
import { FieldProps } from 'formik';
import { IconButton } from 'rsuite';
import Image from '@/components/Bicester/Image';

export interface CheckboxProps extends FieldProps {
  label: string;
  direction?: 'left' | 'right';
  disabled?: boolean;
  onCheck?: (key: string, checked: boolean) => void;
}

export default function Checkbox({
  field,
  form,
  label,
  direction = 'left',
  disabled = false,
  onCheck,
  ...props
}: CheckboxProps) {
  const checked = field.value || false;
  return (
    <IconButton
      className={`formik-checkbox ${checked ? 'checked' : ''}`}
      onClick={() => {
        if (!disabled) {
          onCheck?.(field.name, !checked);
          form.setFieldValue(field.name, !checked);
        }
      }}
    >
      {direction === 'left' && <div className="text-[16px] mr-[5px]">{label}</div>}
      <Image src={`/resources/images/checkbox${checked ? '-checked-fill' : ''}.svg`} />
      {direction === 'right' && <div className="text-[16px] ml-[5px]">{label}</div>}
    </IconButton>
  );
}
